import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Input, Button } from "@nextui-org/react";
import Header from "../../reusable/Header";
import PoweredBy from "../../reusable/PoweredBy";
import { EmailIcon } from "../../icons/EmailIcon";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function EmailInput({ error, sendOtp, setEmailInput }) {
    const { t } = useTranslation();
    const [value, setValue] = useState("");
    const [touched, setTouched] = useState(false);

    const isInvalid = touched && !EMAIL_REGEX.test(value);
    const canSubmit = EMAIL_REGEX.test(value);

    const handleChange = (val) => {
        setValue(val);
        setEmailInput(val);
    };

    const handleSubmit = () => {
        setTouched(true);
        if (canSubmit) sendOtp();
    };

    return (
        <div className="flex h-full flex-col">
            <Header />
            <div className="flex flex-col p-5 h-full justify-between">

                {/* Heading + Input grouped */}
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col items-center text-center gap-1">
                        <div className="heading text-xl">{t("emailCheck.input.heading")}</div>
                        <div className="desc text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("emailCheck.input.description")}</div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Input
                            type="email"
                            placeholder={t("emailCheck.input.placeholder")}
                            variant="bordered"
                            color="primary"
                            radius="sm"
                            size="lg"
                            startContent={<EmailIcon width={24} height={24} fill="var(--urtentic-sdk-primary, #255CFF)" />}
                            value={value}
                            onValueChange={handleChange}
                            onBlur={() => setTouched(true)}
                            isInvalid={isInvalid}
                            errorMessage={isInvalid ? t("emailCheck.input.invalidEmail") : ""}
                        />
                        {error && <div className="text-red-500 text-sm text-center">{error}</div>}
                    </div>
                </div>

                {/* CTA */}
                <div className="flex flex-col gap-2">
                    <Button
                        color="primary"
                        radius="sm"
                        size="lg"
                        fullWidth
                        isDisabled={!canSubmit}
                        onClick={handleSubmit}
                    >
                        {t("emailCheck.input.submitButton")}
                    </Button>
                    <div className="flex justify-center">
                        <PoweredBy />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default EmailInput;
